import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
              FAQ
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              Everything you need to know about using a Pandabuy Spreadsheet
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}